var checkIsTablet = function (isTablet, width) {
    return isTablet ? width : undefined;
};
export default checkIsTablet;
